import {Component, OnDestroy, OnInit} from '@angular/core';
import {TitleFaviconService} from "./title-fav-icon.service";
import {ConfigProvider} from '@mydocma/common';
import {IMmConfig} from '@docma-mm-core/project/project.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'mydocma-app-template';

  constructor(private titleFaviconService: TitleFaviconService,
              private readonly configService: ConfigProvider<IMmConfig>) {
  }

  ngOnInit() {
    this.titleFaviconService.setTitleAndFavicon(this.configService.getConfigData().appName);
  }

  ngOnDestroy(): void {
  }





}

